import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogledriveComponent } from './simple-icons-googledrive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogledriveComponent ],
    exports:      [ SimpleIconsGoogledriveComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogledriveModule {}
